export default __webpack_public_path__ + "static/media/koleos-gallery-3.d176fac2.jpg";